import clsx from 'clsx'
import ReactDOM from "react-dom"
import React, { FC, Fragment } from "react"
import { Transition, Dialog, TransitionChild, DialogPanel } from "@headlessui/react"

import { classNames } from "../../utils/Helpers"
import { BespokeProps } from "../../utils/Interfaces"
import { Loading } from "../../components/utils/Loading"
import { Thematic } from "../../components/utils/Thematic"
import { ErrorState } from "../../views/errors/ErrorState"

export const BespokePanel: FC<BespokeProps> = ({
    show,
    status,
    title,
    showOrHide,
    description,
    components,
    httpStatus = 500,
    size = 'md'
}) => {
    return ReactDOM.createPortal(
        <React.Fragment>
            <Transition show={show} as={Fragment}>
                <Dialog as="div" className="relative z-30" onClose={showOrHide}>
                    <TransitionChild
                        as={Fragment}
                        enter="ease-in-out duration-500"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-500"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-slate-500 dark:bg-slate-900/60 bg-opacity-75 transition-opacity" />
                    </TransitionChild>

                    <div className="fixed inset-0 overflow-hidden w-full">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                                <TransitionChild
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <DialogPanel className={classNames(
                                        size === 'sm' ? 'lg:max-w-sm md:max-w-sm' : null,
                                        size === 'md' ? 'lg:max-w-md md:max-w-md' : null,
                                        size === 'lg' ? 'lg:max-w-lg md:max-w-lg' : null,
                                        size === 'xl' ? 'lg:max-w-xl md:max-w-lg' : null,
                                        size === '2xl' ? 'lg:max-w-2xl md:max-w-xl' : null,
                                        size === '3xl' ? 'lg:max-w-3xl md:max-w-2xl' : null,
                                        size === '4xl' ? 'lg:max-w-4xl md:max-w-3xl' : null,
                                        size === '5xl' ? 'lg:max-w-5xl md:max-w-4xl' : null,
                                        size === '6xl' ? 'lg:max-w-6xl md:max-w-5xl' : null,
                                        "pointer-events-auto relative w-screen md:p-2.5 md:rounded-md"
                                    )}>
                                        <Thematic>
                                            <div className={clsx(
                                                status !== 'fulfilled' && "align-middle items-center justify-center",
                                                "flex h-full flex-col bg-white dark:bg-slate-800 shadow-xl overflow-y-auto md:rounded-md"
                                            )}>
                                                {
                                                    status === 'rejected' ? (
                                                        <ErrorState
                                                            code={httpStatus}
                                                        />
                                                    ) : status === 'fulfilled' ? (
                                                        <>
                                                            <div className="w-full px-4 py-3 md:px-5 flex-none">
                                                                <div className="top-0 left-0 flex flex-row-reverse align-middle items-center">
                                                                    <button type="button" className="rounded-md text-slate-800 dark:text-slate-300 hover:text-slate-800 dark:hover:text-slate-800 focus:outline-none flex flex-row align-middle" onClick={showOrHide}>
                                                                        <span className="sr-only text-sm ml-3">Close panel</span>

                                                                        <svg className="w-5 h-5 mb-1 block" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true" data-slot="icon">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                                                        </svg>
                                                                    </button>

                                                                    <div className="flex-grow">
                                                                        <h2 className="text-xl font-medium text-slate-800 dark:text-slate-300">
                                                                            {title}
                                                                        </h2>
                                                                    </div>
                                                                </div>

                                                                {
                                                                    description && (
                                                                        <div className="top-0 left-0 flex text-slate-800 dark:text-slate-400">
                                                                            <p className="text-sm ">
                                                                                {description}
                                                                            </p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>

                                                            {
                                                                components
                                                            }
                                                        </>
                                                    ) : (
                                                        <Loading />
                                                    )
                                                }
                                            </div>
                                        </Thematic>
                                    </DialogPanel>
                                </TransitionChild>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </React.Fragment>,
        document.getElementById('root')
    )
}
